(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wy-permission-icon", [], factory);
	else if(typeof exports === 'object')
		exports["wy-permission-icon"] = factory();
	else
		root["wy-permission-icon"] = factory();
})(window, function() {
return 